import type { AppearanceAsset } from '../../../../generated/graphql-manager';

import { useTranslation } from 'react-i18next';

import { Asset } from './asset';
import { AppearanceAssetType } from '../../../../generated/graphql-manager';

import styles from './logo-and-favicon.module.css';

const COPY = 'manager.branding.logoAndFavicon.fileUpload';
const { LOGO, HORIZONTAL_LOGO, FAVICON } = AppearanceAssetType;

type Props = {
  themeId: string;
  assets: AppearanceAsset[];
  onActionStart?: () => void;
  onActionComplete?: () => void;
};

export function LogoAndFavicon({ themeId, assets, onActionStart, onActionComplete }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Asset
        themeId={themeId}
        asset={assets.find(({ type }) => type === LOGO)}
        assetType={LOGO}
        acceptedFormats=".jpg, .jpeg, .png, .svg, .gif"
        maximumFileSize={2097152} // 2MB
        heading={t(`${COPY}.${LOGO}.name`)}
        additionalUploadInformation={[t(`${COPY}.${LOGO}.restrictions`), t(`${COPY}.${LOGO}.recommendations`)]}
        onActionStart={onActionStart}
        onActionComplete={onActionComplete}
      />

      <Asset
        themeId={themeId}
        asset={assets.find(({ type }) => type === HORIZONTAL_LOGO)}
        assetType={HORIZONTAL_LOGO}
        acceptedFormats=".jpg, .jpeg, .png, .svg, .gif"
        maximumFileSize={2097152} // 2MB
        heading={t(`${COPY}.${HORIZONTAL_LOGO}.name`)}
        additionalUploadInformation={[
          t(`${COPY}.${HORIZONTAL_LOGO}.restrictions`),
          t(`${COPY}.${HORIZONTAL_LOGO}.recommendations`),
        ]}
        onActionStart={onActionStart}
        onActionComplete={onActionComplete}
      />

      <Asset
        themeId={themeId}
        asset={assets.find(({ type }) => type === FAVICON)}
        assetType={FAVICON}
        acceptedFormats=".ico, .svg"
        maximumFileSize={2097152} // 2MB
        heading={t(`${COPY}.${FAVICON}.name`)}
        additionalUploadInformation={[t(`${COPY}.${FAVICON}.restrictions`), t(`${COPY}.${FAVICON}.recommendations`)]}
        onActionStart={onActionStart}
        onActionComplete={onActionComplete}
      />
    </div>
  );
}
